"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/BAFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_19)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_19`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30.007V24H-6V0Z",
					fill: "#10338C"
				}),
				/* @__PURE__ */ n("path", {
					d: "M1.01053 0H25.0105V24",
					fill: "#F6C500"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.477192 1.78943L-0.0771942 0.0911865L-0.624563 1.78943H-2.4L-0.961405 2.82803L-1.50877 4.51224L-0.0771942 3.47364L1.36842 4.51224L0.814034 2.82803L2.25263 1.78241L0.477192 1.78943Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.56491 4.85609L3.01754 3.17188L2.47017 4.85609H0.701752L2.13333 5.9017L1.58596 7.58591L3.01754 6.54731L4.46316 7.58591L3.91579 5.9017L5.34737 4.85609H3.56491Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.58947 7.88068L6.04211 6.18945L5.49474 7.88068H3.7193L5.1579 8.9263L4.61053 10.6105L6.04211 9.57191L7.48772 10.6105L6.93333 8.9263L8.37193 7.87366L6.58947 7.88068Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.61404 10.8982L9.06667 9.21399L8.5193 10.8982H6.73685L8.18246 11.9508L7.63509 13.635L9.06667 12.5894L10.4983 13.635L9.95088 11.9508L11.3965 10.8982H9.61404Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.6386 13.9229L12.0912 12.2386L11.5439 13.9229H9.7614L11.207 14.9685L10.6596 16.6597L12.0912 15.6141L13.5228 16.6597L12.9754 14.9615L14.414 13.9229H12.6386Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.6632 16.9474L15.1088 15.2632L14.5614 16.9474H12.786L14.2246 17.986L13.6702 19.6842L15.1158 18.6386L16.5474 19.6772L16 17.986L17.4386 16.9474H15.6632Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M18.6807 19.9719L18.1333 18.2737L17.586 19.9719H15.8105L17.2421 21.0105L16.6947 22.7018L18.1333 21.6561L19.5719 22.7018L19.0246 21.0105L20.4561 19.9719H18.6807Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.1579 21.2982L20.6035 22.9894L18.8281 22.9965L20.2175 24H22.0842L23.4807 22.9894H21.7053L21.1579 21.2982Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_19`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as BAFlag };
